export default __webpack_public_path__ + "static/media/testifyOne.cc719c81.png";